import { FormGroup, Input, Label } from "reactstrap";
import { USER_INFO_HEAD } from "../../../../Data/Dashboard";

export const UserInformationTableHead = () => {
  return (
    <thead>
      <tr>
        <th>
          <FormGroup check>
            <Input id="flexCheckDefault" type="checkbox" defaultValue="" />
            <Label check htmlFor="flexCheckDefault"></Label>
          </FormGroup>
        </th>
        {USER_INFO_HEAD.map((item, index) => (
          <th key={index}>{item}</th>
        ))}
      </tr>
    </thead>
  );
};
